import React, { useState } from 'react';

interface WhereTheyAgreeProps {
  consensusPoints: string[];
}

const WhereTheyAgree: React.FC<WhereTheyAgreeProps> = ({ consensusPoints }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!consensusPoints || consensusPoints.length === 0) return null;

  return (
    <div className="max-w-[812px] mx-auto px-4 md:px-0 mb-4">
      <div
        className="bg-white rounded-[14px] border border-[#e2e8f0] overflow-hidden"
        style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}
      >
        {/* Header — always visible, acts as toggle */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-50/50 transition-colors"
        >
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#059669"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <span
              className="text-[14px] font-bold text-slate-900"
              style={{ fontFamily: "'Source Serif 4', Georgia, serif" }}
            >
              Where They All Agree
            </span>
            <span
              className="text-[11px] text-[#94a3b8] tracking-wider"
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            >
              {consensusPoints.length} points of consensus
            </span>
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#94a3b8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="transition-transform shrink-0"
            style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        {/* Expanded content */}
        {isExpanded && (
          <div className="px-5 pb-5 flex flex-col gap-2">
            {consensusPoints.map((point, i) => (
              <div key={i} className="bg-[#f8fafc] rounded-lg p-3 flex items-start gap-3">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#059669"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="shrink-0 mt-1"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <p
                  className="text-[14px] text-[#334155] leading-relaxed"
                  style={{ fontFamily: "'Source Serif 4', Georgia, serif" }}
                >
                  {point}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WhereTheyAgree;
